var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('soupe-ui-tree',{attrs:{"records":_vm.records}},[_c('template',{slot:"soupe-ui-tree-item-controls"},[_c('a',[_c('i',{staticClass:"icon fas fa-bars"})])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }